import Loader from 'components/SimpleLoader'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { logout } from 'services/auth'
import { StoreThunkDispatch } from 'store/state'

function Logout() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const navigate = useNavigate()

  useEffect(() => {
    console.log('Logging out user...')
    dispatch(logout())
    navigate('/login', { replace: true })
  }, [dispatch, navigate])

  return <Loader />
}

export default Logout
